<template>
  <div>
    <!-- :meta="meta"
    :headers="_headers"
    :items="list" -->
    <ListingLayout
      :is-loading="isLoading"
      selected-product="cso"
      :product-options="productOptions"
      :filter-names="filterNames"
      search-label="search"
      :show-data-table="false"
      @filterOption="onFiltersChange"
    >
      <template #description>
        <div>
          <v-tabs
            v-model="tab"
            grow
          >
            <v-tab
              v-for="(item, i) in tabOptions"
              :key="i"
            >
              <div class="tab-button">
                <div>{{ item?.value }}</div>
                <p>{{ item?.text }}</p>
              </div>
            </v-tab>

            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="(item, i) in tabOptions"
                :key="i"
              >
                <v-card
                  color="basil"
                  flat
                >
                  <v-card-text v-if="item?.key == 'signal'">
                    <Signal />
                  </v-card-text>
                  <v-card-text v-else-if="item?.key == 'ledger'">
                    <Ledger />
                  </v-card-text>
                  <v-card-text v-else-if="item?.key == 'adaptive'">
                    <Adaptive />
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </div>
      </template>
      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <!-- <template #actionModals>
        <div></div>
      </template> -->
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
    // Tabs
    Signal: () => import("./tabs/Signal.vue"),
    Ledger: () => import("./tabs/Ledger.vue"),
    Adaptive: () => import("./tabs/Adaptive.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      permissions: {
        view: "config-management.view",
        create: "config-management.create",
        edit: "config-management.edit",
        delete: "config-management.delete",
      },
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      filters: {},
      subFilters: {},
      //
      tab: null,
      tabOptions: [
        { key: "signal", value: "Signal", text: "Ops Command" },
        { key: "ledger", value: "Ledger", text: "Executive" },
        { key: "adaptive", value: "Adaptive", text: "Role-Switchable" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csmsChargeStations/getLoading",
      meta: "csmsChargeStations/getMeta",
      list: "csmsChargeStations/getList",
    }),
    _headers() {
      const headers = [
        // {
        //   text: this.$t("id"),
        //   align: "left",
        //   sortable: true,
        //   value: "id",
        // },
        {
          text: this.$t("charge_point_id"),
          align: "left",
          sortable: false,
          value: "charge_point_id",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        {
          text: this.$t("manufacturer"),
          align: "left",
          sortable: false,
          value: "manufacturer",
        },
        ...(this.authUser.user_nature == "fleet"
          ? [
              {
                text: this.$t("manufacturer"),
                align: "left",
                sortable: false,
                value: "tenant_name",
              },
            ]
          : []),
        {
          text: this.$t("location"),
          align: "left",
          sortable: false,
          value: "location_name",
        },
        // {
        //   text: this.$t("station_type"),
        //   align: "left",
        //   sortable: false,
        //   value: "station_type",
        // },
        {
          text: this.$t("connectors"),
          align: "center",
          sortable: false,
          value: "charger_connectors_count",
        },
        {
          text: this.$t("power_type"),
          align: "center",
          sortable: false,
          value: "type",
        },
        {
          text: this.$t("access_level"),
          align: "left",
          sortable: false,
          value: "is_private",
        },
        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "charge_station_status",
        },
        {
          text: this.$t("last_heartbeat_received"),
          align: "left",
          sortable: false,
          value: "last_heartbeat_received",
        },
        {
          text: this.$t("actions"),
          align: "left",
          sortable: false,
          value: "actions",
        },
        // ...(this.isView || this.isEdit || this.isDelete
        //   ? [
        //       {
        //         text: this.$t("actions"),
        //         align: "left",
        //         sortable: false,
        //         value: "actions",
        //       },
        //     ]
        //   : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["search", "status"];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {},
  beforeDestroy() {
    const params = {
      name: "revenue_share",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options };
      await this.$store.dispatch("revenueShare/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },
  },
};
</script>
<style lang="sass" scoped>
.tab-button
  padding-top: 1rem
  p
    font-size: 9px
    color: gray
</style>
